import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { IBreadcrumb } from '../../shared/interfaces/breadcrumb.type';
import { ThemeConstantService } from '../../shared/services/theme-constant.service';
import { BreadcrumbExtraService, IBreadcrumbExtraItem } from '../../shared/services/breadcrumb-extra.service';

@Component({
    selector: 'app-common-layout',
    templateUrl: './common-layout.component.html',
})

export class CommonLayoutComponent implements OnInit {

    breadcrumbs$: Observable<IBreadcrumb[]>;
    breadcrumbExtra$: Observable<IBreadcrumbExtraItem[]>;
    contentHeaderDisplay: string;
    isFolded: boolean ;
    isSideNavDark: boolean;
    isExpand: boolean;
    selectedHeaderColor: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private themeService: ThemeConstantService,
        private breadcrumbExtraService: BreadcrumbExtraService,
    ) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let child = this.activatedRoute.firstChild;
                while (child) {
                    if (child.firstChild) {
                        child = child.firstChild;
                    } else if (child.snapshot.data && child.snapshot.data['headerDisplay']) {
                        return child.snapshot.data['headerDisplay'];
                    } else {
                        return null;
                    }
                }
                return null;
            })
        ).subscribe( (data: any) => {
            this.contentHeaderDisplay = data;
        });

        // Limpia el breadcrumb extra al navegar a otra pantalla, para que
        // no se arrastre un nivel "Ver Detalle" que ya no aplica.
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
        ).subscribe(() => this.breadcrumbExtraService.clear());
    }

    ngOnInit() {
        this.breadcrumbs$ = this.router.events.pipe(
            startWith(new NavigationEnd(0, '/', '/')),
            filter(event => event instanceof NavigationEnd),distinctUntilChanged(),
            map(data => this.buildBreadCrumb(this.activatedRoute.root))
        );
        this.breadcrumbExtra$ = this.breadcrumbExtraService.items$;
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
        this.themeService.selectedHeaderColor.subscribe(color => this.selectedHeaderColor = color);   
        this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);   
    }

    private buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
        // tslint:disable-next-line:prefer-const
        let label = '', path = '/', display = null;
        if (route.routeConfig) {            
            if (route.routeConfig.data) {
                label = route.routeConfig.data['title'];   
                if(route.routeConfig.data['prefix']) {
                    path +=  '/' + route.routeConfig.data['prefix'] + '/';
                }
                if(route.routeConfig.data['childId']){
                    path += route.params['value'].id;
                }else{
                    path += route.routeConfig.path;
                }
            }            

        } else {
            // Default home base!            
            // label = 'Dashboard';
            // path += '/dashboard';
        }        

       
        // const nextUrl = path && path !== '/dashboard' ? `${url}${path}` : url;    
        const nextUrl = path  ? `${url}${path}` : url;    
        const breadcrumb = <IBreadcrumb>{
            label: label, url: nextUrl
        };    
                   
        const newBreadcrumbs = label ? [...breadcrumbs, breadcrumb] : [...breadcrumbs];
        if (route.firstChild) {            
            return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
        }
        return newBreadcrumbs;
    }

    linkClick(url){
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([url]);
    }
}